import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneReferendum2026 extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio2026 = "/elezioni/withub/referendum-2026-02/referendum/" + regione + "/" + regione + ".html";
    let repoFascione2026 = "/elezioni/withub/referendum-2026-02/referendum/fascione-elezioni.html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione2026} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio2026} />
    </div>
    )
  }
}

export default withParams(RegioneReferendum2026)
